<template>
    <div class="social-btns d-flex align-center justify-center">
        <v-btn width="40" height="40" v-for="(item, i) in items" :key="'social-btn-' + i" tag="a" target="_blank" dark icon :href="item.url" style="background: rgba(0, 0, 0, 0.3)" :class="{'me-2': i != items.length-1}">
            <v-icon>{{item.icon}}</v-icon>
        </v-btn>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    data(){
        return {
            items: [
                {icon: 'mdi-youtube', url: 'https://www.youtube.com/mabi3aat'},
                {icon: 'mdi-facebook', url: 'https://www.facebook.com/mabi3aat'},
                {icon: 'mdi-facebook-messenger', url: 'https://m.me/mabi3aat'},
                {icon: 'mdi-twitter', url: 'https://www.twitter.com/mabi3aat'},
            ]
        }
    },
    computed: {
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    }
}
</script>

<style lang="scss" scoped>

</style>